module.exports = __webpack_public_path__ + "static/media/metropolis-bold.dea4998b.otf";